export default __webpack_public_path__ + "assets/png/efaa004ee6e1d12586674ef68fb32b4e.png";